import merge from 'lodash/merge';
import { normalize } from 'normalizr';

import {
  INITIALIZE,
  EVENT_TIMELINE_PROPS,
  LOAD_EVENT,
  LOAD_EVENT_SUCCESS,
  LOAD_EVENT_FAIL,
  LOAD_AUDITS,
  LOAD_AUDITS_SUCCESS,
  LOAD_AUDITS_FAIL,
  LOAD_MESSAGES,
  LOAD_MESSAGES_SUCCESS,
  LOAD_MESSAGES_FAIL,
} from 'actions/timelineReport/TimelineChartActions';
import { arrayOfAudits, event } from 'actions/timelineReport/schema';

export const defaultState = {
  auditsLoading: true,
  data: {},
  error: false,
  eventId: '',
  eventLoading: true,
  loading: true,
  locale: 'en',
  maxAuditSize: 3000,
  messages: {},
  messagesLoading: true,
  timezone: 'America/Vancouver',
};

export default function timelineReport(state = defaultState, action) {
  switch (action.type) {
    case INITIALIZE:
      return defaultState;
    case LOAD_EVENT:
      return {
        ...state,
        eventLoading: true,
      };
    case EVENT_TIMELINE_PROPS:
      return {
        ...state,
      };
    case LOAD_EVENT_SUCCESS: {
      const normalized = normalize(action.payload, event);
      return {
        ...state,
        eventLoading: false,
        loading: state.auditsLoading || state.messagesLoading,
        data: merge({}, state.data, normalized.entities),
        eventId: normalized.result,
      };
    }
    case LOAD_EVENT_FAIL:
      return {
        ...state,
        eventLoading: false,
        loading: false,
        error: true,
      };
    case LOAD_AUDITS:
      return {
        ...state,
        auditsLoading: true,
      };
    case LOAD_AUDITS_SUCCESS: {
      const normalized = normalize(action.payload.data, arrayOfAudits);
      return {
        ...state,
        auditsLoading: false,
        loading: state.eventLoading || state.messagesLoading,
        data: merge({}, state.data, normalized.entities),
        auditIds: normalized.result,
      };
    }
    case LOAD_AUDITS_FAIL:
      return {
        ...state,
        auditsLoading: false,
        loading: false,
        error: true,
      };
    case LOAD_MESSAGES:
      return {
        ...state,
        messagesLoading: true,
      };
    case LOAD_MESSAGES_SUCCESS:
      return {
        ...state,
        messagesLoading: false,
        loading: state.auditsLoading || state.eventLoading,
        messages: action.payload,
      };
    case LOAD_MESSAGES_FAIL:
      return {
        ...state,
        messagesLoading: false,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}
